export default __webpack_public_path__ + "static/media/sixthIconRight.f9052b79.svg";